import {Field, Formik, FormikHelpers as FormikActions} from 'formik';
import React from 'react';
import {Button} from '~/components/Button';
import {EditorField, Form, FormColumn, FormControls, FormRow, FormTitle, IntentText, SelectField, TagsField} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';
import {MultiSelectSellerField} from '~/modules/Clients/components/SelectSeller';
import {
    defaultConfigsManipulation,
    IConfigsManipulation,
    Operation,
    operations,
    targets
} from '~/modules/Clients/models/ConfigsManipulation';

interface IConfigsManipulationFormProps {
    onSubmit?: (values: IConfigsManipulation, formikActions: FormikActions<IConfigsManipulation>, close: IModalComponentClose) => void;
}

export const ConfigsManipulationForm: IModalComponent<IConfigsManipulationFormProps> = props =>
    <Formik initialValues={defaultConfigsManipulation}
        onSubmit={(values, actions) => props.onSubmit(values, actions, props.close)}
    >
        {({isSubmitting, values: {operation}, status}) => <Form>
            <FormTitle>Update configs</FormTitle>
            {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
            <FormRow>
                <FormColumn>
                    <Field name='sellerIds'
                        label='Sellers'
                        options={{
                            placeholder: 'sellers',
                            disabled: isSubmitting,
                        }}
                        component={MultiSelectSellerField}
                    />
                    <Field name='target'
                        label='Target'
                        options={{
                            placeholder: 'target',
                            items: targets,
                            disabled: isSubmitting
                        }}
                        component={SelectField}
                    />
                    <Field name='operation'
                        label='Operation'
                        options={{
                            placeholder: 'operation',
                            items: operations,
                            disabled: isSubmitting
                        }}
                        component={SelectField}
                    />
                </FormColumn>
            </FormRow>
            <FormRow>
                <FormColumn>
                    {operation === Operation.CREATE && <Field name='configuration'
                        options={{
                            mode: 'json',
                            disabled: isSubmitting
                        }}
                        component={EditorField}
                    />}
                    {operation === Operation.UPDATE && <Field name='configuration'
                        options={{
                            mode: 'json',
                            disabled: isSubmitting
                        }}
                        component={EditorField}
                    />}
                    {operation === Operation.DELETE && <Field name='keys'
                        options={{
                            placeholder: 'options to delete',
                            disabled: isSubmitting
                        }}
                        component={TagsField}
                    />}
                </FormColumn>
            </FormRow>
            <FormControls>
                <Button disabled={isSubmitting}
                    onClick={props.close}
                >Cancel</Button>
                <Button type='submit'
                    disabled={isSubmitting}
                    intent={Intent.PRIMARY}
                    rightIcon={isSubmitting && <i className='fa fa-spinner fa-spin'/>}
                >Apply</Button>
            </FormControls>
        </Form>}
    </Formik>;
